let capsLock = false;

export function handleKeyboardEvent(e) {
  const charCode = e.keyCode || e.which;
  let charStr = String.fromCharCode(charCode);
  switch (charCode) {
    case 8:
      charStr = 'BACKSPACE'
      break;
    case 16:
    case 18:
      charStr = ''
      break;
    case 13:
      charStr = 'OK'
      break;
    case 37:
      charStr = 'KEYBOARDLEFT'
      break;
    case 39:
      charStr = 'KEYBOARDRIGHT'
      break;
    case 46:
      charStr = 'DELETE'
      break;

      // Shift + numbers
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
    case 48:
    case 189:
    case 187:
      charStr = e.key;
      break;

    // Numeric keypad
    case 96:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 109:
    case 110:
    case 111:
      charStr = e.key;
      break;

    // Function keys
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
    case 123:
      charStr = '';
      break;

    // Keys when numlock is off
    case 33:
    case 34:
    case 35:
    case 36:
    case 38:
    case 40:
    case 45:
      charStr = ''
      break;

    // Special characters
    case 186:
    case 188:
    case 190:
    case 191:
    case 192:
    case 219:
    case 220:
    case 221:
    case 222:
    case 226:
      charStr = e.key;
      break;
    default:
      break;
  }

  if (e.key === 'CapsLock') { capsLock = !capsLock; charStr = ''; }
  if (e.key === 'U+0009' ||
      e.key === 'Control' ||
      e.key === 'Alt' ||
      e.key === 'Dead') {
    charStr = '';
  }

  if (e.shiftKey || capsLock) {
    charStr = charStr.toUpperCase();
  } else {
    charStr = charStr.toLowerCase();
  }
  return charStr;
}



// WEBPACK FOOTER //
// src/functions/KeyboardFunctions.js